// extracted by mini-css-extract-plugin
export default {"empty__wrap":"DataEmpty_empty__wrap__wobzN","empty":"DataEmpty_empty__5JWtG"};